/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, price: NonNullable<unknown>, days: NonNullable<unknown> }} Receipt_FormulaInputs */



/**
* | output |
* | --- |
* | "{count} × {price} × {days} days" |
*
* @param {Receipt_FormulaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_formula = /** @type {((inputs: Receipt_FormulaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_FormulaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} × ${i?.price} × ${i?.days} Tage`)
	return /** @type {LocalizedString} */ (`${i?.count} × ${i?.price} × ${i?.days} days`)
});